import styled, { css } from 'styled-components';

import GatekeepingActionsTooltip from './component';

const tooltipStyles = css`
  && {
    padding: 0;
    background: #fff;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.4);
    border-radius: 8px;
    opacity: 1;
    width: 200px;
  }
`;

export default styled(GatekeepingActionsTooltip)`
  ${tooltipStyles}

  .separator {
    margin: 0 16px;
    border-bottom: 1px solid var(--grey200);
  }

  .action_button {
    height: 36px;
    padding: 0 16px;
    display: flex;
    text-align: none;
    align-items: center;
    justify-content: flex-start;
    text-decoration: none;
    width: 100%;
    text-align: left;
    color: var(--grey800);
    border: 0;
    background: transparent;
    &:hover {
      cursor: pointer;
      background-color: var(--primary100);
    }

    overflow: hidden;
    white-space: nowrap;
    outline: none;

    &:first-child {
      border-radius: 8px 8px 0 0;
    }

    &:last-child {
      border-radius: 0 0 8px 8px;
    }
  }
`;
